import { render, staticRenderFns } from "./CreateLinkSuccess.vue?vue&type=template&id=145e3e50&"
import script from "./CreateLinkSuccess.vue?vue&type=script&lang=js&"
export * from "./CreateLinkSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports